import React, { useState } from 'react'
import { StaticQuery, graphql, navigate } from 'gatsby'
import Helmet from 'react-helmet'
import LocaleContext from './Locale'
import NavBar from './NavBar'
import NavBarTray from './NavBarTray'
import OffcanvasDrawer from './Offcanvas'
import lang from '../../static/lang.json'
import UsProductAlert from './UsProductAlert'

/** menu from config */
const navigationQuery = graphql`
  query {
    site {
      siteMetadata {
        menuItems {
          en_ca {
            link
            label
          }
          fr_ca {
            link
            label
          }
          en_us {
            link
            label
          }
        }
      }
    }
  }
`

const Navigation = () => {
  const [link, setLink] = useState('/')

  return (
    <LocaleContext.Consumer>
      {({ locale }) => {
        let initalLocal = locale
        let hrefLangLabel

        if (locale === 'en-ca') {
          hrefLangLabel = lang.translation.fr
        } else if (locale === 'fr-ca') {
          hrefLangLabel = lang.translation.en
        } else if (!locale) {
          initalLocal = '/'
        }

        return (
          <StaticQuery
            query={navigationQuery}
            render={({ site: { siteMetadata } }) => {
              const settings = {
                ...siteMetadata,
                locale: initalLocal,
                hrefLangLabel,
                link,
              }
              return (
                <React.Fragment>
                  <Helmet
                    onChangeClientState={() => {
                      let match = `/${locale}`
                      document
                        .querySelectorAll('[rel="alternate"]')
                        .forEach((node) => {
                          const key = node
                            .getAttribute('hreflang')
                            .toLowerCase()
                          const val = node.getAttribute('href')
                          if (key !== 'en-us' && key !== locale) match = val
                        })

                      setLink(match)
                    }}
                  />
                  {locale !== 'en-us' && (
                    <NavBarTray
                      hideOnMobile
                      label={hrefLangLabel}
                      link={link}
                    />
                  )}
                  <UsProductAlert />
                  <NavBar {...settings}>
                    <OffcanvasDrawer {...settings} />
                  </NavBar>
                </React.Fragment>
              )
            }}
          />
        )
      }}
    </LocaleContext.Consumer>
  )
}

Navigation.propTypes = {}
export default Navigation
